import { Tooltip as TooltipPrimitive } from "@base-ui/react/tooltip";
import { cva } from "cva";
import { cn } from "#ui-atoms/lib/utils";
import type { OptionalTenantProp } from "../../../types";
import type { ToolTipParts } from ".";

const baseTooltipVariants = cva({
  base: "relative flex w-fit origin-(--transform-origin) text-balance rounded-md border bg-popover bg-clip-padding px-2 py-1 text-popover-foreground text-xs shadow-black/5 shadow-md transition-[scale,opacity] before:pointer-events-none before:absolute before:inset-0 before:rounded-[calc(var(--radius-md)-1px)] before:shadow-[0_1px_--theme(--color-black/4%)] data-ending-style:scale-98 data-starting-style:scale-98 data-ending-style:opacity-0 data-starting-style:opacity-0 data-instant:duration-0 dark:bg-clip-border dark:before:shadow-[0_-1px_--theme(--color-white/8%)]",
  variants: {
    variant: {
      default: "",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

const BaseTooltipProvider = TooltipPrimitive.Provider;

const BaseTooltip = TooltipPrimitive.Root;

function BaseTooltipTrigger(props: TooltipPrimitive.Trigger.Props) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}

export interface BaseTooltipPopupProps
  extends TooltipPrimitive.Popup.Props,
    OptionalTenantProp {
  align?: TooltipPrimitive.Positioner.Props["align"];
  side?: TooltipPrimitive.Positioner.Props["side"];
  sideOffset?: TooltipPrimitive.Positioner.Props["sideOffset"];
  withArrow?: boolean;
}

function BaseTooltipPopup({
  className,
  align = "center",
  sideOffset = 4,
  side = "top",
  children,
  tenant,
  ...props
}: BaseTooltipPopupProps) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Positioner
        align={align}
        className="z-50"
        data-slot="tooltip-positioner"
        side={side}
        sideOffset={sideOffset}
      >
        <TooltipPrimitive.Popup
          className={cn(baseTooltipVariants({}), className)}
          data-slot="tooltip-content"
          {...props}
        >
          {children}
        </TooltipPrimitive.Popup>
      </TooltipPrimitive.Positioner>
    </TooltipPrimitive.Portal>
  );
}

export {
  BaseTooltipProvider,
  BaseTooltip,
  BaseTooltipTrigger,
  BaseTooltipPopup,
};

export const baseTooltipKit: ToolTipParts = {
  Provider: BaseTooltipProvider,
  Root: BaseTooltip,
  Trigger: BaseTooltipTrigger,
  Popup: BaseTooltipPopup,
};
